import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./pages/Home";
import Products from "./pages/Products";
import CursorTrail from "./components/CursorTrail";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        {/* Custom Cursor Trail */}
        <CursorTrail />
        
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
